import { useSocketEvent, useSocketState } from '../helpers/useSocket';
import { countdownRenderer } from '../helpers/countdownRenderer';
import { DraftCiv } from '../components/DraftCiv';
import { DraftMap } from '../components/DraftMap';
import { mergeCivDraftView, mergeMapDraftView } from '../helpers/mergeDraftView';
import React, { useState } from 'react';
import Countdown from 'react-countdown';
import { MatchGame } from '../components/MatchGame';

export default function DraftDisplay() {
    const [config, setConfig] = useState({cssTheme: "default.css"});
    const [match] = useSocketState('Match');
    const [civDraft] = useSocketState('CivDraft');
    const [mapDraft] = useSocketState('MapDraft');

    const civDraftView = civDraft && match ? mergeCivDraftView(civDraft?.view || {}, match.games, match.matchRedraftAfter) : {};
    const mapDraftView = mapDraft && match ? mergeMapDraftView(mapDraft?.view || {}, match.games, 0) : {};

    useSocketEvent('updateConfig', (newdata) => {
        console.log(`Received updateConfig`, newdata);
        setConfig(newdata)
    })

    return (
        // <div className="postgame" style={{
        //     "--left-player-color": colors[extraInfo.leftColor]?.mainColor,
        //     "--left-player-color-secondary": colors[extraInfo.leftColor]?.secondaryColor,
        //     "--right-player-color": colors[extraInfo.rightColor]?.mainColor,
        //     "--right-player-color-secondary": colors[extraInfo.rightColor]?.secondaryColor
        // }}>
        <div>
            <link rel="stylesheet" type="text/css" href={`/themes/${config.cssTheme}`} />
            {match &&
                <>
                    <h1 className='draft__roundInfo'>{match.roundInfo}</h1>
                    <h1 className='draft__status'>{match.matchStatus}</h1>
                </>
            }
            {match &&
                <>
                    <h1 className='draft__leftName'>{match.leftPlayer.name}</h1>
                    <h1 className='draft__rightName'>{match.rightPlayer.name}</h1>
                </>
            }
            {match &&
                <>
                    <h1 className='draft__leftScore'>{match.leftPlayer.score}</h1>
                    <h1 className='draft__rightScore'>{match.rightPlayer.score}</h1>
                </>
            }
            {match &&
                <>
                    <h1 className='draft__format'>{match.matchType}</h1>
                </>
            }
            {civDraftView?.host &&
                <div className='draft__civs'>
                    <div className='draft__left draft__leftAllPicks civ__draft '>
                        {civDraftView.host.map((draftOption, i) => <DraftCiv key={i} civ={draftOption.option} state={draftOption.action} status={draftOption.status} randomized={draftOption.randomized} result={draftOption.result} />)}
                    </div>
                    <div className='draft__left draft__leftCivPicks civ__draft'>
                        {civDraftView.host.filter(draftOption => draftOption.action === 'pick').map((draftOption, i) => <DraftCiv key={i} civ={draftOption.option} state={draftOption.action} status={draftOption.status} randomized={draftOption.randomized} result={draftOption.result} />)}
                    </div>
                    <div className='draft__left draft__leftCivBans civ__draft'>
                        {civDraftView.host.filter(draftOption => draftOption.action === 'ban').map((draftOption, i) => <DraftCiv key={i} civ={draftOption.option} state={draftOption.action} status={draftOption.status} randomized={draftOption.randomized} result={draftOption.result} />)}
                    </div>
                    <div className='draft__right draft__rightAllPicks civ__draft'>
                        {civDraftView.guest.map((draftOption, i) => <DraftCiv key={i} civ={draftOption.option} state={draftOption.action} status={draftOption.status} randomized={draftOption.randomized} result={draftOption.result} />)}
                    </div>
                    <div className='draft__right draft__rightCivPicks civ__draft'>
                        {civDraftView.guest.filter(draftOption => draftOption.action === 'pick').map((draftOption, i) => <DraftCiv key={i} civ={draftOption.option} state={draftOption.action} status={draftOption.status} randomized={draftOption.randomized} result={draftOption.result} />)}
                    </div>
                    <div className='draft__right draft__rightCivBans civ__draft'>
                        {civDraftView.guest.filter(draftOption => draftOption.action === 'ban').map((draftOption, i) => <DraftCiv key={i} civ={draftOption.option} state={draftOption.action} status={draftOption.status} randomized={draftOption.randomized} result={draftOption.result} />)}
                    </div>
                </div>
            }
            {mapDraftView?.host &&
                <>
                    <div className='draft__left map__draft'>
                        {mapDraftView.host.map((draftOption, i) => <DraftMap key={i} map={draftOption.option} state={draftOption.action} status={draftOption.status} randomized={draftOption.randomized} result={draftOption.result} />)}
                    </div>
                    <div className='draft__right map__draft'>
                        {mapDraftView.guest.map((draftOption, i) => <DraftMap key={i} map={draftOption.option} state={draftOption.action} status={draftOption.status} randomized={draftOption.randomized} result={draftOption.result} />)}
                    </div>
                </>
            }
            {match?.countdownTimer &&
                <div className='match__countdown'>
                    <Countdown date={match.countdownTimer} renderer={countdownRenderer} />
                </div>}
            {match?.games &&
                <div className='matchGames'>
                    {
                        match.games.filter(game => game.state !== 'tbd').map((game, i) => <MatchGame key={i} game={game} />)
                    }
                </div>
            }

        </div>
    )
}
